import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import PageLayout from "core/LayoutContainers/PageLayout";

function CustomBasicLayout({ children }) {
  return (
    <PageLayout>
      <MDBox
        width="100%"
        minHeight="100vh"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        sx={{
          backgroundImage: `url('/images/background.jpg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          py: 4,
        }}
      >
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs={11} sm={9} md={5} lg={4} xl={3}>
            {children}
          </Grid>
        </Grid>
      </MDBox>
    </PageLayout>
  );
}

CustomBasicLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CustomBasicLayout; 